module.exports = __webpack_public_path__ + "static/media/blue-star.e7509542.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/features/blue-star.png
// module id = 1577
// module chunks = 0